import React from 'react';
import { BarChart2Icon, PlusIcon } from 'lucide-react';
import { familyMembers } from '../../data/carte';
interface FamilySectionProps {
  selectedId: string;
  onSelect: (id: string) => void;
}
export function FamilySection({
  selectedId,
  onSelect
}: FamilySectionProps) {
  return <section aria-labelledby="famille-titre" className="mt-8 rounded-3xl bg-slate-50 p-7 sm:p-8" data-id="element-617" data-mp="cypv02j0iuya">
      <h2 id="famille-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-618" data-mp="3bgvetlw6gouj">
        Ma famille
      </h2>

      <ul className="mt-6 grid grid-cols-4 gap-x-4 gap-y-6" data-id="element-619" data-mp="3ggrjzogm2mbo">
        {familyMembers.map(member => {
        const active = member.id === selectedId;
        return <li key={member.id} className="text-center" data-id="element-620" data-mp="3q59iu05byjco">
              <div className="inline-block" data-id="element-621" data-mp="3q6ubtlbzxu8f">
                <button type="button" onClick={() => onSelect(member.id)} aria-pressed={active} aria-label={`Afficher la carte de ${member.firstName}`} className="rounded-full transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-622" data-mp="2sqnipnqwaynu">
                  <img src={member.photo} alt={member.firstName} className={`h-[76px] w-[76px] rounded-full object-cover ring-4 ${active ? 'ring-ville-indigo' : 'ring-white'}`} data-id="element-623" data-mp="19l977hwzjjcz" />
                </button>
              </div>
              <p className="mt-2 text-[15px] font-bold leading-tight text-ville-navy" data-id="element-624" data-mp="qnolgjpip0wl">{member.firstName}</p>
            </li>;
      })}

        <li data-id="element-625" data-mp="lqy4zv9sw3an">
          <button type="button" className="group flex w-full flex-col items-center text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-626" data-mp="lr7yhsu20sl3">
            <span className="grid h-[76px] w-[76px] place-items-center rounded-full bg-white text-slate-400 ring-1 ring-slate-200 transition-colors duration-150 ease-ville group-hover:text-ville-indigo group-hover:ring-ville-indigo" data-id="element-627" data-mp="2g1bjo7lspg8o">
              <PlusIcon className="h-7 w-7" aria-hidden="true" data-id="element-628" data-mp="4gazm48jxmx7" />
            </span>
            <span className="mt-2 text-[15px] font-bold leading-tight text-ville-indigo" data-id="element-629" data-mp="9embslmbk9il">Ajouter</span>
          </button>
        </li>
      </ul>

      <div className="mt-6 flex items-start gap-3 rounded-2xl bg-ville-indigo-soft px-5 py-4" data-id="element-630" data-mp="x5rpov8p8rq9">
        <BarChart2Icon className="mt-0.5 h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-631" data-mp="1228ezsrmxc4x" />
        <div className="text-[15px] leading-relaxed text-ville-indigo" data-id="element-632" data-mp="o30aqlgm7dtv">
          <p className="font-semibold" data-id="element-633" data-mp="s4u7iinovxor">Activités familiales : 3 cette semaine</p>
          <p data-id="element-634" data-mp="38u0vp4y8kjgu">Dernier accès : Emma au Complexe aquatique</p>
        </div>
      </div>
    </section>;
}